import decode from 'jwt-decode';
import {BaseService} from './BaseService';
export default class ContactService extends BaseService {
  getProfile() {
      // Using jwt-decode npm package to decode the token
      return decode(this.getToken());
  }
  getContacts(search) {
    let isNullOrEmpty = require('is-null-or-empty');
    let query = '';
    if (!isNullOrEmpty(search)) {
      query = `?search=${search}`;
    }
    return this.fetch(`${this.domain}/search${query}`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }
  getContact(id) {
    return this.fetch(`${this.domain}/contacts?id=${id}`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  getContactsNameAndCuit() {
    return this.fetch(`${this.domain}/contacts/name-and-cuit`, {method: 'GET'}).then(res => {
      return Promise.resolve(res);
    })
  }

  shareContacts(id, users) {
    let currentUser = this.getProfile();
    users = users.map( function(item) {
      return item.value;
    });
    let contact = {"id": id, "users": users.join(','), "createdby": currentUser.username};

    return this.fetch(`${this.domain}/contacts/share`, {
        method: 'POST',
        body: JSON.stringify({
            "contacto": contact
          })
    }).then(res => {
        return Promise.resolve(res);
    })
  }
  updateContact(id, contact) {
    var currentUser = this.getProfile();
    var contacto = contact;
    contacto['id'] = id;
    contacto['createdby'] = currentUser.username;

    return this.fetch(`${this.domain}/contacts`, {
        method: 'PUT',
        body: JSON.stringify({
            "contacto" : contacto
          })
    }).then(res => {
        return Promise.resolve(res);
    })
  }
  createContact(contact) {
    var currentUser = this.getProfile();
    var contacto = contact;
    contacto['createdBy'] = currentUser.username;

    return this.fetch(`${this.domain}/contacts`, {
        method: 'POST',
        body: JSON.stringify({
            "contacto" : contacto
          })
    }).then(res => {
        return Promise.resolve(res);
    })
  }
  deleteContact(id) {
    return this.fetch(`${this.domain}/contacts?id=${id}`, {
      method: 'DELETE'
    })
    .then(res => {
      return Promise.resolve(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/ContactService.js